import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, FormGroup, Label, Form } from "reactstrap";
import { CheckBoxSelection, Inject, MultiSelectComponent } from '@syncfusion/ej2-react-dropdowns';
import { FaTrashAlt } from 'react-icons/fa';
import { GetWorkorderTechnician, GetWorkOrderBuildingsList, GetWorkOrderBuildingsEquipments, GetWorkOrderEquipments  } from '../../../../../action/workorderAction';

class PMReportFilter extends Component {
    async componentWillMount(){
        const l_Technician = this.props.GetWorkorderTechnician();
        const l_Building = this.props.GetWorkOrderBuildingsList();
        const l_BuildingEquipment = this.props.GetWorkOrderBuildingsEquipments(0);
        const l_Equipment = this.props.GetWorkOrderEquipments();
        await Promise.all([l_Technician, l_Building, l_BuildingEquipment, l_Equipment]);
        if (this.props.IsEdit) {
            let preferredfields = this.props.getPreferences;
            //var label = this.props.getLabels;
            var selectedStatusId = [], selectedAssignedToId = [], selectedBuildingId = [], selectedEquipmentId = [];
            var selectedStatus = [], selectedAssignedTo = [], selectedBuilding = [], selectedEquipment = [];
            var lFilters = this.props.SavedData;
            var l_IsSingleBuildingSelected = false;
            if (lFilters.Status !== null) {
                var status = (preferredfields !== "" && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
                if (status.length > 0 && status[0].value.length > 0) {
                    lFilters.Status.forEach(el => {
                        var Data = status[0].value.filter(ele => ele.key === el.statusID)[0];
                        selectedStatus.push({ "id": el.statusID, "value": Data !== undefined ? Data.value : "" });
                        selectedStatusId.push(el.statusID);
                    });
                }
            }
            if (lFilters.AssignedTo !== null) {
                if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length) {
                    lFilters.AssignedTo.forEach(el => {
                        var Data1 = this.props.getTechnicianList.filter(ele => ele.technicianID === el.assignedUserID)[0];
                        selectedAssignedTo.push({ "id": el.assignedUserID, "value": Data1 !== undefined ? Data1.name : "" });
                        selectedAssignedToId.push(el.assignedUserID);
                    });
                }
            }
            if (lFilters.Building !== null) {
                if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length) {
                    lFilters.Building.forEach(el => {
                        var Data2 = this.props.getWorkOrderBuildings.filter(ele => ele.id === el.buildingID)[0];
                        if(Data2 !== undefined && !Data2.isDeleted){
                            selectedBuilding.push({ "id": el.buildingID, "value": Data2 !== undefined ? Data2.name : "", "siteId": el.buildingID });
                            selectedBuildingId.push(el.buildingID);
                        }
                        l_IsSingleBuildingSelected = (lFilters.Building.length === 1 && selectedBuildingId.length === 0) ? true : false; 
                    });
                }
            }
            if (lFilters.Equipment !== null) {
                if (this.props.getBuildingEquipments !== undefined && this.props.getBuildingEquipments !== null && this.props.getBuildingEquipments.length) {
                    lFilters.Equipment.forEach(el => {
                        var Data3, Data2;
                        var buildingeqp = this.props.getBuildingEquipments;
                        buildingeqp.forEach(el1 => {
                            if (el1.equipment !== undefined && el1.equipment !== null && el1.equipment.length) {
                                if (el1.equipment.filter(ele => ele.objectId === el.equipmentID)[0] !== undefined) {
                                    Data2 = el1.equipment.filter(ele => ele.objectId === el.equipmentID)[0];
                                }
                            }
                        })
                        if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length) {
                            Data3 = this.props.getWorkOrderBuildings.filter(ele => ele.id === el.buildingID)[0];
                        }
                        if (Data2 !== undefined && Data3 !== undefined && !Data3.isDeleted) {
                            selectedEquipment.push({ "id": el.equipmentID, "value": (Data2 !== undefined ? Data2.objectName : "") + (Data2 !== undefined ? ',   ' + Data3.name : ""), "siteId": el.buildingID });
                            selectedEquipmentId.push(el.equipmentID);
                        }
                    });
                }
                if (this.props.getEquipments !== undefined && this.props.getEquipments !== null && this.props.getEquipments.length) {
                    lFilters.Equipment.forEach(el => {
                        var Data1;
                        if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length) {
                            Data1 = this.props.getWorkOrderBuildings.filter(ele => ele.id === el.buildingID)[0];
                        }
                        var Data2 = this.props.getEquipments.filter(ele => ele.id === el.equipmentID)[0];
                        if (Data2 !== undefined && Data1 !== undefined && !Data1.isDeleted) {
                            selectedEquipment.push({ "id": el.equipmentID, "value": (Data2 !== undefined ? Data2.name : "") + (Data2 !== undefined ? ',   ' + Data2.buildingName : ""), "siteId": el.buildingID });
                            selectedEquipmentId.push(el.equipmentID);
                        }
                    });
                }
            }

            this.setState({
                SelectedStatus: selectedStatusId,
                SelectedStatusList: selectedStatus,
                SelectedAssignedTo: selectedAssignedToId,
                SelectedAssignedToList: selectedAssignedTo,
                SelectedBuilding: selectedBuildingId,
                SelectedBuildingList: selectedBuilding,
                SelectedEquipment: selectedEquipmentId,
                SelectedEquipmentList: selectedEquipment,
                IsSingleBuildingDeleted: l_IsSingleBuildingSelected
            });
        }
    }

    constructor(props) {
        super(props);
        this.state = {
            SelectedStatusList : [],
            SelectedStatus : [],
            SelectedAssignedToList : [],
            SelectedAssignedTo : [],
            SelectedBuildingList : [],
            SelectedBuilding : [],
            SelectedEquipmentList : [],
            SelectedEquipment : [],
            IsSingleBuildingDeleted: false
        }
        this.DeleteStatus = this.DeleteStatus.bind(this);
        this.DeleteAssignedTo = this.DeleteAssignedTo.bind(this);
        this.DeleteBuilding = this.DeleteBuilding.bind(this);
        this.DeleteEquipment = this.DeleteEquipment.bind(this);
        this.dropdown_fields = { text: 'value', value: 'id' };
    }

    OnSort(values) {
        if(values !== undefined && values !== null && values !== "--"){
            const sorted_data = values.sort((a, b) => {
                let nameA, nameB;
                nameA = a.orderId;
                nameB = b.orderId;
                return (nameA - nameB);
            });
            return sorted_data;
        }
    }

    onStatusSelect(args) { 
        var selectedStatusId = null;
        var l_SelectedStatus = this.state.SelectedStatusList;
        l_SelectedStatus.push(args.itemData);
        if(l_SelectedStatus !== undefined && l_SelectedStatus != null && l_SelectedStatus.length){
            selectedStatusId = l_SelectedStatus.map(el => ( el.id ));
        }
        this.setState({ SelectedStatusList : l_SelectedStatus, SelectedStatus : selectedStatusId });
        this.props.FilterSelection({"Type":"Status","Ids":l_SelectedStatus});
    }

    onStatusRemove(args){ 
        var selectedStatusId = null;
        var lSelectedStatus = this.state.SelectedStatusList;
        var FilteredData = lSelectedStatus.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedStatusId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedStatusList : FilteredData, SelectedStatus : selectedStatusId });
        this.props.FilterSelection({"Type":"Status","Ids":FilteredData});
    }

    DeleteStatus(StatusId){ 
        var selectedStatusId = null;
        var lSelectedStatus = this.state.SelectedStatusList;
        var FilteredData = lSelectedStatus.filter(x => x.id !== StatusId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedStatusId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedStatusList : FilteredData, SelectedStatus : selectedStatusId });
        this.props.FilterSelection({"Type":"Status","Ids":FilteredData});
    }

    onAssignedToSelect(args) { 
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        l_SelectedAssignedTo.push(args.itemData);
        if(l_SelectedAssignedTo !== undefined && l_SelectedAssignedTo != null && l_SelectedAssignedTo.length){
            selectedAssignedToId = l_SelectedAssignedTo.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : l_SelectedAssignedTo, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":l_SelectedAssignedTo});
    }

    onAssignedToRemove(args){
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedAssignedToId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : FilteredData, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    DeleteAssignedTo(AssignedToId){ 
        var selectedAssignedToId = null;
        var l_SelectedAssignedTo = this.state.SelectedAssignedToList;
        var FilteredData = l_SelectedAssignedTo.filter(x => x.id !== AssignedToId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedAssignedToId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedAssignedToList : FilteredData, SelectedAssignedTo : selectedAssignedToId });
        this.props.FilterSelection({"Type":"AssignedTo","Ids":FilteredData});
    }

    onBuildingSelect(args) { 
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        l_SelectedBuilding.push(args.itemData);   
        if(l_SelectedBuilding !== undefined && l_SelectedBuilding != null && l_SelectedBuilding.length){
            selectedBuildingId = l_SelectedBuilding.map(el => ( el.id ));
        }    
        this.setState({ SelectedBuildingList : l_SelectedBuilding, SelectedBuilding : selectedBuildingId, IsSingleBuildingDeleted: false });
        this.DeleteBuildingEquipment(l_SelectedBuilding);
        this.props.FilterSelection({"Type":"Building","Ids":l_SelectedBuilding});
    }

    onBuildingRemove(args){
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        var FilteredData = l_SelectedBuilding.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedBuildingId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedBuildingList : FilteredData, SelectedBuilding : selectedBuildingId });
        this.DeleteBuildingEquipment(FilteredData);
        this.props.FilterSelection({"Type":"Building","Ids":FilteredData});
    }

    DeleteBuilding(BuildingId){ 
        var selectedBuildingId = null;
        var l_SelectedBuilding = this.state.SelectedBuildingList;
        var FilteredData = l_SelectedBuilding.filter(x => x.id !== BuildingId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedBuildingId = FilteredData.map(el => ( el.id ));
        }
        
        this.setState({ SelectedBuildingList : FilteredData, SelectedBuilding : selectedBuildingId });
        this.DeleteBuildingEquipment(FilteredData);
        this.props.FilterSelection({"Type":"Building","Ids":FilteredData});
    }

    onEquipmentSelect(args) { 
        var selectedEquipmentId = null;
        var l_SelectedEquipment = this.state.SelectedEquipmentList;
        l_SelectedEquipment.push(args.itemData);
        if(l_SelectedEquipment !== undefined && l_SelectedEquipment != null && l_SelectedEquipment.length){ 
            selectedEquipmentId = l_SelectedEquipment.map(el => ( el.id ));
        }
        this.setState({ SelectedEquipmentList : l_SelectedEquipment, SelectedEquipment : selectedEquipmentId });
        this.props.FilterSelection({"Type":"Equipment","Ids":l_SelectedEquipment});
    }

    onEquipmentRemove(args){
        var selectedEquipmentId = null;
        var l_SelectedEquipment = this.state.SelectedEquipmentList;
        var FilteredData = l_SelectedEquipment.filter(x => x.id !== args.itemData.id);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){ 
            selectedEquipmentId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedEquipmentList : FilteredData, SelectedEquipment : selectedEquipmentId });
        this.props.FilterSelection({"Type":"Equipment","Ids":FilteredData});
    }

    DeleteEquipment(EquipmentId){ 
        var selectedEquipmentId = null;
        var l_SelectedEquipment = this.state.SelectedEquipmentList;
        var FilteredData = l_SelectedEquipment.filter(x => x.id !== EquipmentId);
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){ 
            selectedEquipmentId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedEquipmentList : FilteredData, SelectedEquipment : selectedEquipmentId });
        this.props.FilterSelection({"Type":"Equipment","Ids":FilteredData});
    }

    DeleteBuildingEquipment(SelectedBuildingList){ 
        var selectedEquipmentId = null,FilteredData = [];
        var l_SelectedEquipment = this.state.SelectedEquipmentList;
        var l_SelectedBuildings = SelectedBuildingList;
         
        l_SelectedBuildings.forEach(el => {
                //Status_in_Select_input.push({ "id" : el.key, "value" : el.value });
            if (l_SelectedEquipment.filter(x => x.siteId === el.id).length > 0)
                {
                       var equip = l_SelectedEquipment.filter(x => x.siteId === el.id);
                       FilteredData.push.apply(FilteredData,equip); 
                       //FilteredData.values.
                }
        });
             
        if(FilteredData !== undefined && FilteredData != null && FilteredData.length){
            selectedEquipmentId = FilteredData.map(el => ( el.id ));
        }
        this.setState({ SelectedEquipmentList : FilteredData, SelectedEquipment : selectedEquipmentId });
        this.props.FilterSelection({"Type":"Equipment","Ids":FilteredData});
    }

    render() {
        let label = this.props.getLabels;
        let preferredfields = this.props.getPreferences;
        var Status_in_Select_input = [], Assigned_in_Select_input = [], Building_in_Select_input = [], Equipment_in_Select_input = [];
        var StatusList = [], AssignedToList = [], BuildingList = [], EquipmentList = [];
        var BuildingsList = [],EquipmentsList = [];var l_Equipmentdata = [];
        var DropdownClass = this.state.IsSingleBuildingDeleted ? "customerrorhighlight" : "WO_Filter_Multi_Ddl"; 
        
        var status = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Status" && x.display === true) : "";
        var assignedto = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Assigned To" && x.display === true) : "";
        var building = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Building" && x.display === true) : "";
        var equipment = (preferredfields !== ""  && preferredfields !== undefined) ? preferredfields.filter(x => x.field === "Equipment" && x.display === true) : "";

        //Status
        var Status = label['PreventativeMaintenance.Status.Text'].split(',');
        if (status.length > 0) {
            if (status[0].value.length > 0) {
                var status_values = this.OnSort(status[0].value);
                status_values.forEach(el => {
                    Status_in_Select_input.push({ "id" : el.key, "value" : el.value });
                });
            }
        }else {
            Status.forEach(el => {
                Status_in_Select_input.push({ "id" : el, "value" : label['PreventativeMaintenance.Status.' + el + '.Text'] });
            });
        }
        if (this.state.SelectedStatusList !== undefined && this.state.SelectedStatusList !== null && this.state.SelectedStatusList.length) {
            // StatusList = this.state.SelectedStatusList.map((el, index) => (
            //     <tr key={index}>
            //         <td className="workorderlbl" style={{ width: "50%", bordertop: "0 solid" }}>{el.value}</td>
            //         <td><img src={DeleteIcon} alt="StatusImg" style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteStatus(el.id) }} /></td>
            //     </tr>
            // ));

            var lstStatus = this.state.SelectedStatusList;
            const rows = [...Array( Math.ceil(lstStatus.length / 3) )];
            // chunk the products into the array of rows
            const productRows = rows.map( (row, idx) => lstStatus.slice(idx * 3, idx * 3 + 3) );
            // map the rows as div.row
            StatusList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  {/* map products in the row as article.col-md-3 */}
                  { row.map( product => <div key={product.id} className="col-md-4">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteStatus(product.id) }} /></div>
                  </div> )}
                </div> 
            ));



        }

        //AssignedTo
        if (this.props.getTechnicianList !== undefined && this.props.getTechnicianList !== null && this.props.getTechnicianList.length) {
            this.props.getTechnicianList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).forEach(el => {
                Assigned_in_Select_input.push({ "id" : el.technicianID, "value" : el.name });
            });
        }
        if (this.state.SelectedAssignedToList !== undefined && this.state.SelectedAssignedToList !== null && this.state.SelectedAssignedToList.length) {
            // AssignedToList = this.state.SelectedAssignedToList.map((el, index) => (
            //     <tr key={index}>
            //         <td className="workorderlbl" style={{ width: "50%", bordertop: "0 solid" }}>{el.value}</td>
            //         <td><img src={DeleteIcon} alt="StatusImg" style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteAssignedTo(el.id) }} /></td>
            //     </tr>
            // ));

            var lstData4 = this.state.SelectedAssignedToList;
            const rows = [...Array( Math.ceil(lstData4.length / 3) )];
            // chunk the products into the array of rows
            const productRows = rows.map( (row, idx) => lstData4.slice(idx * 3, idx * 3 + 3) );
            // map the rows as div.row
            AssignedToList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  {/* map products in the row as article.col-md-3 */}
                  { row.map( product => <div key={product.id} className="col-md-4">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteAssignedTo(product.id) }} /></div>
                  </div> )}
                </div> 
            ));


        }

        //Building
        if (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null && this.props.getWorkOrderBuildings.length > 0)
            BuildingsList = this.props.getWorkOrderBuildings.filter(el => el.isDeleted === false);
        if (BuildingsList !== undefined && BuildingsList !== null && BuildingsList.length > 0) {
            BuildingsList.sort((a,b) => (a.name.toLowerCase() > b.name.toLowerCase()) - (a.name.toLowerCase() < b.name.toLowerCase())).forEach(el => {
                Building_in_Select_input.push({ "id" : el.id, "value" : el.name, "siteId" : el.siteId });
            });
        }
        if (this.state.SelectedBuildingList !== undefined && this.state.SelectedBuildingList !== null && this.state.SelectedBuildingList.length) {
            // BuildingList = this.state.SelectedBuildingList.map((el, index) => (
            //     <tr key={index}>
            //         <td className="workorderlbl" style={{ width: "50%", bordertop: "0 solid" }}>{el.value}</td>
            //         <td><img src={DeleteIcon} alt="StatusImg" style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteBuilding(el.id) }} /></td>
            //     </tr>
            // ));

            var lstData3 = this.state.SelectedBuildingList;
            const rows = [...Array( Math.ceil(lstData3.length / 3) )];
            const productRows = rows.map( (row, idx) => lstData3.slice(idx * 3, idx * 3 + 3) );
            BuildingList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  { row.map( product => <div key={product.id} className="col-md-4">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteBuilding(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        //For Discovered Equipment
        if (this.props.getBuildingEquipments !== undefined && this.props.getBuildingEquipments !== null && this.props.getBuildingEquipments.length > 0)
        {
            var Equiplineitem = '';
            let l_getBuildingEquipments = [];
            if (this.state.SelectedBuildingList !== undefined && this.state.SelectedBuildingList !== null && this.state.SelectedBuildingList.length){
                this.state.SelectedBuildingList.forEach(el => {
                    var actualSiteId = 0;
                    var l_MappedSite = (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null) ? this.props.getWorkOrderBuildings.filter(x => x.id === el.id) : [];
                    if (l_MappedSite !== undefined && l_MappedSite.length > 0) {
                        actualSiteId = l_MappedSite[0].siteId;
                    }
                    l_getBuildingEquipments.push(this.props.getBuildingEquipments.filter(x => x.siteId === actualSiteId));
                });
                
                l_getBuildingEquipments.forEach(building => {                
                    building.forEach(buildingdetail => {
                        if (buildingdetail.equipment !== undefined && buildingdetail.equipment !== null && buildingdetail.equipment.length > 0) {
                            let siteName = buildingdetail.siteName;
                            let siteId = buildingdetail.siteId;
                            let l_WOBuildingId = (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null) ? this.props.getWorkOrderBuildings.filter(x => x.siteId === siteId && !x.isDeleted) : [];
                            buildingdetail.equipment.forEach(element => {
                                Equiplineitem = {
                                    "Id": element.objectId,
                                    "Name": element.objectName,
                                    "Location": siteName,
                                    "SubId": 0,
                                    "SiteId": (l_WOBuildingId[0] !== undefined && l_WOBuildingId[0] !== null) ? l_WOBuildingId[0].id : 0
                                }
                                l_Equipmentdata.push(Equiplineitem);
                            });
                        }
                    });
                });
            }
            else {
                l_getBuildingEquipments = this.props.getBuildingEquipments;
                l_getBuildingEquipments.forEach(building => {                  
                    if (building.equipment !== undefined && building.equipment !== null && building.equipment.length > 0) {
                        let siteName = building.siteName;
                        let siteId = building.siteId;
                        let l_WOBuildingId = (this.props.getWorkOrderBuildings !== undefined && this.props.getWorkOrderBuildings !== null) ? this.props.getWorkOrderBuildings.filter(x => x.siteId === siteId && !x.isDeleted) : [];
                        building.equipment.forEach(element => {
                            Equiplineitem = {
                                "Id": element.objectId,
                                "Name": element.objectName,
                                "Location": siteName,
                                "SubId": 0,
                                "SiteId": (l_WOBuildingId[0] !== undefined && l_WOBuildingId[0] !== null) ? l_WOBuildingId[0].id : 0
                            }
                            l_Equipmentdata.push(Equiplineitem);
                        });
                    }                
                });
            }
        }
        
        //For Non Discovered Equipment
        if (this.props.getEquipments !== undefined && this.props.getEquipments !== null && this.props.getEquipments.length > 0)
        {
            Equiplineitem = '';
            let l_getEquipments = []; 
            if (this.state.SelectedBuildingList !== undefined && this.state.SelectedBuildingList !== null && this.state.SelectedBuildingList.length){
                this.state.SelectedBuildingList.forEach(el => {
                    l_getEquipments.push(this.props.getEquipments.filter(x => x.siteId === el.id));
                });  
                l_getEquipments.forEach(NonDiscEquip => {
                    NonDiscEquip.forEach(NonDiscEquipDetail => {
                    Equiplineitem = {
                        "Id": NonDiscEquipDetail.id,
                        "Name": NonDiscEquipDetail.name,
                        "Location": NonDiscEquipDetail.buildingName,
                        "SubId": 1,
                        "SiteId": NonDiscEquipDetail.siteId
                    }
                    l_Equipmentdata.push(Equiplineitem);
                  }); 
                });         
            }
            else {
                l_getEquipments = this.props.getEquipments;
                l_getEquipments.forEach(NonDiscEquip => {
                    Equiplineitem = {
                        "Id": NonDiscEquip.id,
                        "Name": NonDiscEquip.name,
                        "Location": NonDiscEquip.buildingName,
                        "SubId": 1,
                        "SiteId": NonDiscEquip.siteId
                    }
                    l_Equipmentdata.push(Equiplineitem);
                });
            }                      
        }
        EquipmentsList = l_Equipmentdata;

        if (EquipmentsList != null) {
            EquipmentsList.forEach(el => {
                Equipment_in_Select_input.push({ "id" : el.Id, "value" : el.Name + ',   ' + el.Location,"siteId" : el.SiteId });
            });
        }

        if (this.state.SelectedEquipmentList !== undefined && this.state.SelectedEquipmentList !== null && this.state.SelectedEquipmentList.length) {
            // EquipmentList = this.state.SelectedEquipmentList.map((el, index) => (
            //     <tr key={index}>
            //         <td className="workorderlbl" style={{ width: "50%", bordertop: "0 solid" }}>{el.value}</td>
            //         <td><img src={DeleteIcon} alt="StatusImg" style={{width:'18px', marginLeft:'3px', valign:'bottom' }} className="link_cursor" onClick={() => { this.DeleteEquipment(el.id) }} /></td>
            //     </tr>
            // ));

            var lstData6 = this.state.SelectedEquipmentList;
            const rows = [...Array( Math.ceil(lstData6.length / 2) )];
            const productRows = rows.map( (row, idx) => lstData6.slice(idx * 2, idx * 2 + 2) );
            EquipmentList = productRows.map((row, idx) => (
                <div className="row" key={idx}>    
                  { row.map( product => <div key={product.id} className="col-md-6">
                    <div><label className="reportsFilterlbl">{product.value}</label><FaTrashAlt style={{ color:"#676767", float:"left" }} className="Ensemble_Icon link_cursor" onClick={() => { this.DeleteEquipment(product.id) }} /></div>
                  </div> )}
                </div> 
            ));
        }

        return (
            <div>
                <Form>
                    <FormGroup row>
                        <Col sm={{ size: 12 }}>
                            <Label id="label_filters" className="reportsHeaderlbl">Filters</Label>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_status" style={{ marginBottom: "0px" }} className="workorderlbl">{status.length > 0 ? status[0].fieldLabel : "Status"}</Label><br />
                            <MultiSelectComponent id="select_status" ref='status_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Status_in_Select_input}  
                                select={this.onStatusSelect.bind(this)}
                                removed={this.onStatusRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedStatus}
                                mode="CheckBox" 
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            {StatusList}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_assignedto" style={{ marginBottom: "0px" }} className="workorderlbl">{assignedto.length > 0 ? assignedto[0].fieldLabel : "Assigned To"}</Label><br />
                            <MultiSelectComponent id="select_assignedto" ref='assigned_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Assigned_in_Select_input}  
                                select={this.onAssignedToSelect.bind(this)}
                                removed={this.onAssignedToRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedAssignedTo}
                                mode="CheckBox" 
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            {AssignedToList}
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_buildings" style={{ marginBottom: "0px" }} className="workorderlbl">{building.length > 0 ? building[0].fieldLabel : "Buildings"}</Label><br />
                            <MultiSelectComponent id="select_buildings" ref='building_in_Select_input' width='100%' cssClass={DropdownClass}
                                dataSource={Building_in_Select_input}  
                                select={this.onBuildingSelect.bind(this)}
                                removed={this.onBuildingRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedBuilding}
                                mode="CheckBox" 
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                            <span hidden={!this.state.IsSingleBuildingDeleted}><Label style={{'color':'#D42D27', 'font-style':'italic','font-size':'10px','font-family':'Lato' }}><b>Selected building(s) no longer in system</b></Label></span>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            {BuildingList}
                        </Col>
                    </FormGroup>

                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            <Label id="label_equipments" style={{ marginBottom: "0px" }} className="workorderlbl">{equipment.length > 0 ? equipment[0].fieldLabel : "Equipment"}</Label><br />
                            <MultiSelectComponent id="select_equipments" ref='Equipment_in_Select_input' width='100%' cssClass="WO_Filter_Multi_Ddl"
                                dataSource={Equipment_in_Select_input} 
                                select={this.onEquipmentSelect.bind(this)}
                                removed={this.onEquipmentRemove.bind(this)}
                                fields={this.dropdown_fields} 
                                value={this.state.SelectedEquipment}
                                mode="CheckBox" 
                                filterType="Contains"
                                showDropDownIcon={true} showSelectAll={true} enableSelectionOrder={false} 
                                filterBarPlaceholder="Search" placeholder="-Select-" selectAllText="Select All" unSelectAllText="Clear All" >
                                <Inject services={[CheckBoxSelection]} />
                            </MultiSelectComponent>
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Col sm={{ size: 6 }}>
                            {EquipmentList}
                        </Col>
                    </FormGroup>

                </Form>
            </div>
        )
    };
};

const mapStateToProps = (state) => {
    return {
        getLabels: state.CulturalLabelsRootReducer.WorkOrderResource_LabelsBasedOnPreference,
        getPreferences: state.authService.preventative_maintenance_user_preferencedetails,
        getTechnicianList: state.WorkorderRootReducer.Technicians,
        getWorkOrderBuildings: state.WorkorderRootReducer.WorkorderBuildings,
        getBuildingEquipments: state.WorkorderRootReducer.BuildingsEquipments,
        getEquipments: state.WorkorderRootReducer.WorkorderEquipments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        GetWorkOrderBuildingsList: () => dispatch(GetWorkOrderBuildingsList()),
        GetWorkorderTechnician: () => dispatch(GetWorkorderTechnician()),
        GetWorkOrderBuildingsEquipments: (BuildingId) => dispatch(GetWorkOrderBuildingsEquipments(BuildingId)),
        GetWorkOrderEquipments: () => dispatch(GetWorkOrderEquipments())
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(PMReportFilter);